var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 890.8 910.7",
    style: {
      enableBackground: "new 0 0 890.8 910.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#262A38;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338,560.4v-35.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v35.6c0,3.3,0,3.3-3.5,3.3C338,563.8,338,563.8,338,560.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M374.3,568.4v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3S374.3,571.7,374.3,568.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M392.3,532.7h15.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-15.6c-3.3,0-3.3,0-3.3-3.5S389,532.7,392.3,532.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.9,545.8h35.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-35.6c-3.3,0-3.3,0-3.3-3.5S431.6,545.8,434.9,545.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.4,488.8H441c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-44.6c-3.3,0-3.3,0-3.3-3.5S393.1,488.8,396.4,488.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466,488.8h15.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5H466c-3.3,0-3.3,0-3.3-3.5S462.7,488.8,466,488.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.3,605.4h33.6c3.4,0,3.4,0,3.4,3.5s0,3.5-3.3,3.5h-32.4v17.3c0,3.5,0,3.5-3.3,3.5c-3.2,0-3.2,0-3.2-3.5 v-19.1C220.1,605.4,220.1,605.4,225.3,605.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M339.9,658.3h15.6c3.3,0,3.3,0,3.3,3.5c0,3.5,0,3.5-3.3,3.5h-15.6c-3.3,0-3.3,0-3.3-3.5 C336.6,658.3,336.6,658.3,339.9,658.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M392.3,610.4h15.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-15.6c-3.3,0-3.3,0-3.3-3.5S389,610.4,392.3,610.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M455.2,609.5c11.3,0,18.3,7.1,19,16.3c0.2,3.2,0.2,6.4,0,9.5c-0.7,9.1-7.7,16.3-19,16.3l-0.1-6.6 c7.7,0,11.7-4.4,12.2-10.4c0.2-2.7,0.2-5.5,0-8.2c-0.5-6.1-4.4-10.4-12.2-10.4L455.2,609.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.8,714.9c0-11.3,7.1-18.3,16.3-19c3.2-0.2,6.4-0.2,9.5,0c9.1,0.7,16.3,7.7,16.3,19l-6.6,0.1 c0-7.7-4.4-11.7-10.4-12.2c-2.7-0.2-5.5-0.2-8.2,0c-6.1,0.5-10.4,4.4-10.4,12.2L420.8,714.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.2,798.3h-15.6c-3.3,0-3.3,0-3.3-3.5s0-3.5,3.3-3.5h15.6c3.3,0,3.3,0,3.3,3.5S383.5,798.3,380.2,798.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M344.4,780.3v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3S344.4,783.6,344.4,780.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M357.6,737.6v-35.5c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v35.6c0,3.3,0,3.3-3.5,3.3 C357.6,740.9,357.6,740.9,357.6,737.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421.7,775.6V760c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3S421.7,778.9,421.7,775.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300,775.8v-44.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v44.6c0,3.3,0,3.3-3.5,3.3S300,779.1,300,775.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300,706.1v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3S300,709.4,300,706.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.2,740.5h-33.6c-3.4,0-3.4,0-3.4-3.5s0-3.5,3.3-3.5h32.4v-17.3c0-3.5,0-3.5,3.3-3.5c3.2,0,3.2,0,3.2,3.5 v19.1C232.4,740.5,232.4,740.5,227.2,740.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.1,826.2h15.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-15.6c-3.3,0-3.3,0-3.3-3.5 C266.8,826.2,266.8,826.2,270.1,826.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.9,825.6h35.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-35.6c-3.3,0-3.3,0-3.3-3.5S337.6,825.6,340.9,825.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.9,828.7v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3S470.9,832,470.9,828.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.2,883.8h35.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-35.6c-3.3,0-3.3,0-3.3-3.5S267.9,883.8,271.2,883.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.3,871.9v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3 C209.3,875.2,209.3,875.2,209.3,871.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.4,885.6v-44.5c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v44.6c0,3.3,0,3.3-3.5,3.3 C167.4,888.9,167.4,888.9,167.4,885.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.5,778.3v44.6c0,3.3,0,3.3-3.5,3.3s-3.5,0-3.5-3.3v-44.6c0-3.3,0-3.3,3.5-3.3 C115.5,775,115.5,775,115.5,778.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.5,876v15.6c0,3.3,0,3.3-3.5,3.3s-3.5,0-3.5-3.3V876c0-3.3,0-3.3,3.5-3.3S115.5,872.7,115.5,876z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.7,851.5h35.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5H18.7c-3.3,0-3.3,0-3.3-3.5S15.4,851.5,18.7,851.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80,778.6v15.6c0,3.3,0,3.3-3.5,3.3s-3.5,0-3.5-3.3v-15.6c0-3.3,0-3.3,3.5-3.3S80,775.3,80,778.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62,814.3H46.4c-3.3,0-3.3,0-3.3-3.5s0-3.5,3.3-3.5H62c3.3,0,3.3,0,3.3,3.5S65.3,814.3,62,814.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.3,688c0-11.3,7.1-18.3,16.3-19c3.2-0.2,6.4-0.2,9.5,0c9.1,0.7,16.3,7.7,16.3,19l-6.6,0.1 c0-7.7-4.4-11.7-10.4-12.2c-2.7-0.2-5.5-0.2-8.2,0c-6.1,0.5-10.4,4.4-10.4,12.2L222.3,688z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.3,641.1h27.2c3.6,0,3.6,0,3.6-3.3c0-3.2,0-3.2-3.6-3.2h-10.2v-6.9V623l-6.9,5.4v1.7v4.4h-10.2 c-3.5,0-3.5,0-3.5,3.2C287.8,641.1,287.8,641.1,291.3,641.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.4,599.3v-11c0-3.3,0-3.3-3.5-3.3c-3.4,0-3.4,0-3.4,3.4v16.4L308.4,599.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165,703.8h-27.3c-3.6,0-3.6,0-3.6,3.3c0,3.2,0,3.2,3.6,3.2h10.2v6.9v4.7l6.9-5.4v-1.7v-4.4H165 c3.5,0,3.5,0,3.5-3.2C168.5,703.8,168.5,703.8,165,703.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.9,745.5v11c0,3.3,0,3.3,3.5,3.3c3.4,0,3.4,0,3.4-3.4v-16.3L147.9,745.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.8,777.3h-27.2c-3.6,0-3.6,0-3.6,3.3c0,3.2,0,3.2,3.6,3.2h10.2v6.9v4.7l6.9-5.4v-1.7v-4.4h10.2 c3.5,0,3.5,0,3.5-3.2C249.3,777.3,249.3,777.3,245.8,777.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.7,802v11c0,3.3,0,3.3,3.5,3.3c3.4,0,3.4,0,3.4-3.4v-16.4L228.7,802z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.7,881.8v-27.2c0-3.6,0-3.6-3.3-3.6c-3.2,0-3.2,0-3.2,3.6v10.2h-6.9h-4.7l5.4,6.9h1.7h4.4v10.2 c0,3.5,0,3.5,3.2,3.5C452.7,885.3,452.7,885.3,452.7,881.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M428,864.7h-11c-3.3,0-3.3,0-3.3,3.5c0,3.4,0,3.4,3.4,3.4h16.4L428,864.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M614.7,681.4h-11.8h-2.5v0.1c-1.6,0.2-1.6,1-1.6,3.7l0,0l0,0c0,2.8,0,3.5,1.6,3.7v0.1h2.5h11.8h2.5v-0.1 c1.6-0.2,1.6-1,1.6-3.7l0,0l0,0c0-2.8,0-3.5-1.6-3.7v-0.1H614.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M558.7,729.3h-11.8h-2.5v0.1c-1.6,0.2-1.6,1-1.6,3.7l0,0l0,0c0,2.8,0,3.5,1.6,3.7v0.1h2.5h11.8h2.5v-0.1 c1.6-0.2,1.6-1,1.6-3.7l0,0l0,0c0-2.8,0-3.5-1.6-3.7v-0.1H558.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M782,500v-35.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3V500c0,3.3,0,3.3-3.5,3.3S782,503.3,782,500z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M741.9,489v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3V489c0,3.3,0,3.3-3.5,3.3S741.9,492.3,741.9,489z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M840.1,473.5v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3S840.1,476.8,840.1,473.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M840.1,560.4v-35.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v35.6c0,3.3,0,3.3-3.5,3.3 C840.1,563.8,840.1,563.8,840.1,560.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M673.4,514.2H689c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-15.6c-3.3,0-3.3,0-3.3-3.5 C670.1,514.2,670.1,514.2,673.4,514.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M727.3,605.4h33.6c3.4,0,3.4,0,3.4,3.5s0,3.5-3.3,3.5h-32.4v17.3c0,3.5,0,3.5-3.3,3.5c-3.2,0-3.2,0-3.2-3.5 v-19.1C722.1,605.4,722.1,605.4,727.3,605.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M841.9,658.3h15.6c3.3,0,3.3,0,3.3,3.5c0,3.5,0,3.5-3.3,3.5h-15.6c-3.3,0-3.3,0-3.3-3.5 C838.6,658.3,838.6,658.3,841.9,658.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M656.8,571.2v44.6c0,3.3,0,3.3-3.5,3.3s-3.5,0-3.5-3.3v-44.6c0-3.3,0-3.3,3.5-3.3S656.8,567.9,656.8,571.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M656.8,640.9v15.6c0,3.3,0,3.3-3.5,3.3s-3.5,0-3.5-3.3v-15.6c0-3.3,0-3.3,3.5-3.3S656.8,637.6,656.8,640.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M592.6,635.1v-35.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v35.6c0,3.3,0,3.3-3.5,3.3S592.6,638.4,592.6,635.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M607.1,586.8v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3S607.1,590.1,607.1,586.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M846.5,780.3v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3S846.5,783.6,846.5,780.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M859.6,737.6v-35.5c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v35.6c0,3.3,0,3.3-3.5,3.3 C859.6,740.9,859.6,740.9,859.6,737.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M802,775.8v-44.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v44.6c0,3.3,0,3.3-3.5,3.3S802,779.1,802,775.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M802,706.1v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3S802,709.4,802,706.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M729.3,740.5h-33.6c-3.4,0-3.4,0-3.4-3.5s0-3.5,3.3-3.5H728v-17.3c0-3.5,0-3.5,3.3-3.5c3.2,0,3.2,0,3.2,3.5 v19.1C734.4,740.5,734.4,740.5,729.3,740.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M772.1,826.2h15.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-15.6c-3.3,0-3.3,0-3.3-3.5S768.8,826.2,772.1,826.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M773.2,883.8h35.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-35.6c-3.3,0-3.3,0-3.3-3.5S769.9,883.8,773.2,883.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M711.3,871.9v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3 C711.3,875.2,711.3,875.2,711.3,871.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M669.4,885.6v-44.5c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v44.6c0,3.3,0,3.3-3.5,3.3 C669.4,888.9,669.4,888.9,669.4,885.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M617.5,778.3v44.6c0,3.3,0,3.3-3.5,3.3s-3.5,0-3.5-3.3v-44.6c0-3.3,0-3.3,3.5-3.3 C617.5,775,617.5,775,617.5,778.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M617.5,876v15.6c0,3.3,0,3.3-3.5,3.3s-3.5,0-3.5-3.3V876c0-3.3,0-3.3,3.5-3.3S617.5,872.7,617.5,876z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M520.7,851.5h35.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-35.6c-3.3,0-3.3,0-3.3-3.5S517.4,851.5,520.7,851.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M582.1,778.6v15.6c0,3.3,0,3.3-3.5,3.3s-3.5,0-3.5-3.3v-15.6c0-3.3,0-3.3,3.5-3.3S582.1,775.3,582.1,778.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M564.1,814.3h-15.6c-3.3,0-3.3,0-3.3-3.5s0-3.5,3.3-3.5h15.6c3.3,0,3.3,0,3.3,3.5S567.4,814.3,564.1,814.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521.4,801.2h-35.6c-3.3,0-3.3,0-3.3-3.5s0-3.5,3.3-3.5h35.6c3.3,0,3.3,0,3.3,3.5S524.7,801.2,521.4,801.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M724.3,688c0-11.3,7.1-18.3,16.3-19c3.2-0.2,6.4-0.2,9.5,0c9.1,0.7,16.3,7.7,16.3,19l-6.6,0.1 c0-7.7-4.4-11.7-10.4-12.2c-2.7-0.2-5.5-0.2-8.2,0c-6.1,0.5-10.4,4.4-10.4,12.2L724.3,688z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M620.1,516.8c-11.3,0-18.3-7.1-19-16.3c-0.2-3.2-0.2-6.4,0-9.5c0.7-9.1,7.7-16.3,19-16.3l0.1,6.6 c-7.7,0-11.7,4.4-12.2,10.4c-0.2,2.7-0.2,5.5,0,8.2c0.5,6.1,4.4,10.4,12.2,10.4L620.1,516.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.5,705h15.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-15.6c-3.3,0-3.3,0-3.3-3.5S505.2,705,508.5,705z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M560.9,657.1h15.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-15.6c-3.3,0-3.3,0-3.3-3.5S557.6,657.1,560.9,657.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M549.3,566.3v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3S549.3,569.6,549.3,566.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521.3,533.5v-44.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v44.6c0,3.3,0,3.3-3.5,3.3S521.3,536.8,521.3,533.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M712,566.7h27.2c3.6,0,3.6,0,3.6-3.3c0-3.2,0-3.2-3.6-3.2H729v-6.9v-4.7l-6.9,5.4v1.7v4.4h-10.2 c-3.5,0-3.5,0-3.5,3.2C708.5,566.7,708.5,566.7,712,566.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M729,542v-11c0-3.3,0-3.3-3.5-3.3c-3.4,0-3.4,0-3.4,3.4v16.4L729,542z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M793.3,641.1h27.2c3.6,0,3.6,0,3.6-3.3c0-3.2,0-3.2-3.6-3.2h-10.2v-6.9V623l-6.9,5.4v1.7v4.4h-10.2 c-3.5,0-3.5,0-3.5,3.2C789.8,641.1,789.8,641.1,793.3,641.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M810.4,599.3v-11c0-3.3,0-3.3-3.5-3.3c-3.4,0-3.4,0-3.4,3.4v16.4L810.4,599.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M667,703.8h-27.2c-3.6,0-3.6,0-3.6,3.3c0,3.2,0,3.2,3.6,3.2H650v6.9v4.7l6.9-5.4v-1.7v-4.4h10.2 c3.5,0,3.5,0,3.5-3.2C670.5,703.8,670.5,703.8,667,703.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M649.9,745.5v11c0,3.3,0,3.3,3.5,3.3c3.4,0,3.4,0,3.4-3.4v-16.3L649.9,745.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M747.8,777.3h-27.2c-3.6,0-3.6,0-3.6,3.3c0,3.2,0,3.2,3.6,3.2h10.2v6.9v4.7l6.9-5.4v-1.7v-4.4h10.2 c3.5,0,3.5,0,3.5-3.2C751.3,777.3,751.3,777.3,747.8,777.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M730.8,802v11c0,3.3,0,3.3,3.5,3.3c3.4,0,3.4,0,3.4-3.4v-16.4L730.8,802z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500.2,596.7v27.2c0,3.6,0,3.6,3.3,3.6c3.2,0,3.2,0,3.2-3.6v-10.2h6.9h4.7l-5.4-6.9h-1.7h-4.4v-10.2 c0-3.5,0-3.5-3.2-3.5C500.2,593.2,500.2,593.2,500.2,596.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M541.9,613.8h11c3.3,0,3.3,0,3.3-3.5c0-3.4,0-3.4-3.4-3.4h-16.4L541.9,613.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.9,385.8v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3S470.9,389.1,470.9,385.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M452.7,438.8v-27.2c0-3.6,0-3.6-3.3-3.6c-3.2,0-3.2,0-3.2,3.6v10.2h-6.9h-4.7l5.4,6.9h1.7h4.4v10.2 c0,3.5,0,3.5,3.2,3.5C452.7,442.3,452.7,442.3,452.7,438.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M428,421.7h-11c-3.3,0-3.3,0-3.3,3.5c0,3.4,0,3.4,3.4,3.4h16.4L428,421.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M614.7,238.4h-11.8h-2.5v0.1c-1.6,0.2-1.6,1-1.6,3.7l0,0l0,0c0,2.8,0,3.5,1.6,3.7v0.1h2.5h11.8h2.5v0.1 c1.6-0.2,1.6-1,1.6-3.7l0,0l0,0c0-2.8,0-3.5-1.6-3.7v-0.1h-2.5V238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M558.7,286.4h-11.8h-2.5v0.1c-1.6,0.2-1.6,1-1.6,3.7l0,0l0,0c0,2.8,0,3.5,1.6,3.7v0.1h2.5h11.8h2.5v-0.1 c1.6-0.2,1.6-1,1.6-3.7l0,0l0,0c0-2.8,0-3.5-1.6-3.7v-0.1H558.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M782,57.1V21.5c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v35.6c0,3.3,0,3.3-3.5,3.3S782,60.4,782,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M840.1,30.5V14.9c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3 C840.1,33.8,840.1,33.8,840.1,30.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M840.1,117.5V81.9c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v35.6c0,3.3,0,3.3-3.5,3.3 C840.1,120.8,840.1,120.8,840.1,117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M727.3,162.5h33.6c3.4,0,3.4,0,3.4,3.5s0,3.5-3.3,3.5h-32.4v17.3c0,3.5,0,3.5-3.3,3.5c-3.2,0-3.2,0-3.2-3.5 v-19.1C722.1,162.5,722.1,162.5,727.3,162.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M841.9,215.3h15.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-15.6c-3.3,0-3.3,0-3.3-3.5 C838.6,215.3,838.6,215.3,841.9,215.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M656.8,128.3v44.6c0,3.3,0,3.3-3.5,3.3s-3.5,0-3.5-3.3v-44.6c0-3.3,0-3.3,3.5-3.3S656.8,125,656.8,128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M656.8,198v15.6c0,3.3,0,3.3-3.5,3.3s-3.5,0-3.5-3.3V198c0-3.3,0-3.3,3.5-3.3 C656.8,194.7,656.8,194.7,656.8,198z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M846.5,337.4v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3S846.5,340.7,846.5,337.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M859.6,294.7v-35.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v35.6c0,3.3,0,3.3-3.5,3.3 C859.6,298,859.6,298,859.6,294.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M802,332.8v-44.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v44.6c0,3.3,0,3.3-3.5,3.3S802,336.1,802,332.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M802,263.2v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v15.6c0,3.3,0,3.3-3.5,3.3C802,266.5,802,266.5,802,263.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M729.3,297.6h-33.6c-3.4,0-3.4,0-3.4-3.5s0-3.5,3.3-3.5H728v-17.3c0-3.5,0-3.5,3.3-3.5c3.2,0,3.2,0,3.2,3.5 v19.1C734.4,297.6,734.4,297.6,729.3,297.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M772.1,383.3h15.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-15.6c-3.3,0-3.3,0-3.3-3.5S768.8,383.3,772.1,383.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M773.2,440.8h35.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-35.6c-3.3,0-3.3,0-3.3-3.5S769.9,440.8,773.2,440.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M711.3,429v-15.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3V429c0,3.3,0,3.3-3.5,3.3S711.3,432.3,711.3,429z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M669.4,442.7v-44.6c0-3.3,0-3.3,3.5-3.3s3.5,0,3.5,3.3v44.6c0,3.3,0,3.3-3.5,3.3 C669.4,446,669.4,446,669.4,442.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M617.5,335.4V380c0,3.3,0,3.3-3.5,3.3s-3.5,0-3.5-3.3v-44.6c0-3.3,0-3.3,3.5-3.3S617.5,332.1,617.5,335.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M617.5,433v15.6c0,3.3,0,3.3-3.5,3.3s-3.5,0-3.5-3.3V433c0-3.3,0-3.3,3.5-3.3 C617.5,429.7,617.5,429.7,617.5,433z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M520.7,408.6h35.6c3.3,0,3.3,0,3.3,3.5s0,3.5-3.3,3.5h-35.6c-3.3,0-3.3,0-3.3-3.5S517.4,408.6,520.7,408.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M582.1,335.6v15.6c0,3.3,0,3.3-3.5,3.3s-3.5,0-3.5-3.3v-15.6c0-3.3,0-3.3,3.5-3.3S582.1,332.3,582.1,335.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M564.1,371.4h-15.6c-3.3,0-3.3,0-3.3-3.5s0-3.5,3.3-3.5h15.6c3.3,0,3.3,0,3.3,3.5S567.4,371.4,564.1,371.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M521.4,358.2h-35.6c-3.3,0-3.3,0-3.3-3.5s0-3.5,3.3-3.5h35.6c3.3,0,3.3,0,3.3,3.5S524.7,358.2,521.4,358.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M724.3,245c0-11.3,7.1-18.3,16.3-19c3.2-0.2,6.4-0.2,9.5,0c9.1,0.7,16.3,7.7,16.3,19l-6.6,0.1 c0-7.7-4.4-11.7-10.4-12.2c-2.7-0.2-5.5-0.2-8.2,0c-6.1,0.5-10.4,4.4-10.4,12.2L724.3,245z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M712,123.8h27.2c3.6,0,3.6,0,3.6-3.3c0-3.2,0-3.2-3.6-3.2H729v-6.9v-4.7l-6.9,5.4v1.7v4.4h-10.2 c-3.5,0-3.5,0-3.5,3.2C708.5,123.8,708.5,123.8,712,123.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M729,99.1v-11c0-3.3,0-3.3-3.5-3.3c-3.4,0-3.4,0-3.4,3.4v16.4L729,99.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M793.3,198.1h27.2c3.6,0,3.6,0,3.6-3.3c0-3.2,0-3.2-3.6-3.2h-10.2v-6.9v-4.6l-6.9,5.4v1.7v4.4h-10.2 c-3.5,0-3.5,0-3.5,3.2C789.8,198.1,789.8,198.1,793.3,198.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M810.4,156.4v-11c0-3.3,0-3.3-3.5-3.3c-3.4,0-3.4,0-3.4,3.4v16.4L810.4,156.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M667,260.8h-27.2c-3.6,0-3.6,0-3.6,3.3c0,3.2,0,3.2,3.6,3.2H650v6.9v4.7l6.9-5.4v-1.7v-4.4h10.2 c3.5,0,3.5,0,3.5-3.2C670.5,260.8,670.5,260.8,667,260.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M649.9,302.6v11c0,3.3,0,3.3,3.5,3.3c3.4,0,3.4,0,3.4-3.4v-16.4L649.9,302.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M747.8,334.4h-27.2c-3.6,0-3.6,0-3.6,3.3c0,3.2,0,3.2,3.6,3.2h10.2v6.9v4.7l6.9-5.4v-1.7V341h10.2 c3.5,0,3.5,0,3.5-3.2C751.3,334.4,751.3,334.4,747.8,334.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M730.8,359.1v11c0,3.3,0,3.3,3.5,3.3c3.4,0,3.4,0,3.4-3.4v-16.4L730.8,359.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.6ac117483d33e8135e541e19d56311f4.svg";
export { ForwardRef as ReactComponent };